import React from 'react';
import { BarChart3 } from 'lucide-react';

const WidgetSummary = ({ 
  showSummary, 
  summaryLoading, 
  summaryError, 
  summaryText, 
  generateSummary 
}) => {
  return (
    <>
      <div 
        className={`mt-5 p-2.5 bg-gray-50 rounded-lg flex items-center justify-center gap-1.5 cursor-pointer ${showSummary ? 'active' : ''}`}
        onClick={generateSummary}
      >
        <BarChart3 className="w-4 h-4 text-purple-600" />
        <span className="font-semibold text-black text-sm">
          {showSummary ? 'Hide Smart Assist' : 'Smart Assist'}
        </span>
      </div>
      
      {showSummary && (
        <div className="mt-2">
          {summaryLoading ? (
            <div className="text-center py-2">
              Generating summary...
            </div>
          ) : summaryError ? (
            <div className="text-red-500">
              {summaryError}
            </div>
          ) : (
            <div
              className="rounded-lg p-2.5 flex items-center gap-1.5 mt-2 text-sm"
              dangerouslySetInnerHTML={{ __html: summaryText }}
            />
          )}
        </div>
      )}
    </>
  );
};

export default WidgetSummary;